<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    :showIsItemImg="true"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}多選題
    </template>

    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">
          {{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}
        </div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        label="題目內容"
        auto-grow
        v-model="ques.cnName"
        v-on:click="checkDef()"
        class="peter-text mb-2"
      ></v-textarea>
      <v-row class="mt-2 ml-0 pr-3">
      <v-file-input
        v-if="isEdit"
        chips
        filled
        class="pt-0"
        v-model="ques.headingFile"
        accept="image/*"
        @change="onImgChangeHeading($event)"
        label="File input"
      >
      </v-file-input>
      </v-row>      
      <v-row>
        <v-col class="pa-0 text-center" >
                <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
                <img
                  v-if="ques.questHeadingPic"
                  :src="ques.questHeadingPic.startsWith('data') ? ques.questHeadingPic : $store.state.server + ques.questHeadingPic"
                  style="max-width: 100%"
                />
              </v-col>
      </v-row>

      <!-- 文字選項編輯區塊 -->
      <template v-if="isEdit">
        <template v-if="!ques.isItemImg">
          <v-row v-for="(opt, idx) in ques.items" :key="idx" class="ml-0 mt-1 pr-3">
            <v-btn
              fab
              dark
              small
              color="primary"
              @click="delOptText(idx)"
              class="mb-2 mr-1"
            >
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
            <v-col class="pa-0 mb-1 ml-1">
              <!-- todo: 這個輸入框有些微不自然的上抬12px暫時處理不好，先把前面的按鈕也上抬 -->
              <v-text-field
                class="peter-text"
                solo
                v-model="ques.items[idx]"
                v-on:mouseup="checkDefAns(idx)"
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="text-center">
            <v-btn class="mx-2 mt-2" fab dark small color="primary" @click="addOptText">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>

        <!-- 圖片選項編輯區塊 -->
        <template v-else>
          <div v-for="(route, idx) in ques.fileRoutes" :key="idx">
            <v-row class="mt-2 ml-0 pr-3">
              <v-btn fab dark small color="primary" @click="delOptImg(idx)" class="mb-3">
                <v-icon dark>mdi-minus</v-icon>
              </v-btn>
              <v-col class="pa-0 mb-3 ml-1">
                <v-file-input
                  chips
                  filled
                  class="pt-0"
                  v-model="ques.files[idx]"
                  accept="image/*"
                  @change="onImgChange($event, idx)"
                  label="File input"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row >
              <v-col class="pa-0" style="margin-left: 90px;">
                <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸-->
                <img
                  v-if="route"
                  :src="route.startsWith('data') ? route : $store.state.server + route"
                  style="max-width: 100%;"
                />
              </v-col>
            </v-row>
          </div>
          <div class="text-center">
            <v-btn class="mx-2 mt-2" fab dark color="primary" @click="addOptImg">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>
      </template>

      <!-- 作答時的選項 -->
      <!-- ripple 需要設定為 fasle，否則會出現 v-ripple__container 類別的 spsn，造成點擊時大小改變 -->
      <template v-if="!isEdit">
        <!-- 選項為文字的情況 -->
        <template v-if="!ques.isItemImg">
          <v-card
            class="px-3 mb-2"
            v-for="(opt, idx) in ques.items"
            :key="idx + opt"
            :ripple="false"
          >
            <v-checkbox v-model="values[idx]" :label="opt" @change="chkOpt(idx)">
              <template slot="message"><div></div></template>
            </v-checkbox>
          </v-card>
        </template>
        <!-- 選項為圖片的情況 -->
        <!-- key值 +1 處理出現0時可能造成update問題 -->
        <template v-else>
          <v-card
            class="px-3 mb-2"
            v-for="(route, idx) in ques.fileRoutes"
            :key="1+idx"
            :ripple="false"
          >
            <v-checkbox v-model="values[idx]" @click="chkOpt(idx)">
              <template slot="label">
                <!-- 破圖修復 -->
                <!-- <v-img :src="$store.state.server + route"></v-img> -->
                <img v-bind:src="$store.state.server + route" style="max-width: 100%" />
              </template>
            </v-checkbox>
          </v-card>
        </template>
      </template>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard,
  },
  data() {
    return {
      values: [],
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '多選題',
          cnName: '多選題題目內容',
          value: null,
          items: ['選項1', '選項2'],
        }
      },
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    chkOpt(idx) {
      this.ques.value = this.values
        .map((x, idx) => (x === true ? idx : null))
        .filter((x) => x !== null)
        .join('$')
      // [Debug]
      // window.console.log(this.ques.value)
    },
    addOptText() {
      this.ques.items.push('')
    },
    delOptText(idx) {
      this.ques.items.splice(idx, 1)
    },
    addOptImg() {
      this.ques.fileRoutes.push('')
      this.ques.files.push(null)
    },
    delOptImg(idx) {
      this.ques.fileRoutes.splice(idx, 1)
      this.ques.files.splice(idx, 1)
    },
    setLoadImg() {},
    onImgChange(file, idx) {
      if (!file) {
        this.ques.fileRoutes[idx] = null
      } else {
      var fileReader = new FileReader()
      fileReader.addEventListener('load', (e) => {
        this.ques.fileRoutes.splice(idx, 1, e.target.result)
      })
      fileReader.readAsDataURL(file)
      }
    },
    checkDef() {
      if (this.QType.CHOICE_MULTIPLE.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }
    },
    checkDefAns(i) {
      if (this.QType.CHOICE_MULTIPLE.template.items[i] === this.ques.items[i]) {
        this.ques.items.splice(i, 1, '')
      }
    },
  },
  computed: {
    QType() {
      return this.$store.state.QType
    },
  },
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls{
  margin-top: 8px !important;
}
.v-messages {
  min-height: 0px !important;
}

</style>
